export enum BasisAccessRulesKeyEnum {
  // --- Модуль BASIS (Базовый) ---

  // --- Раздел BASIS.SECTIONS.DASHBOARD (Рабочий стол) ---
  BASIS_DASHBOARD_TEMPLATE_WRITE = 'BASIS_DASHBOARD_TEMPLATE_WRITE',

  // Виджеты
  BASIS_DASHBOARD_ACCOUNTS_CASHES_MONEY_WIDGETS = 'BASIS_DASHBOARD_ACCOUNTS_CASHES_MONEY_WIDGETS',
  BASIS_DASHBOARD_PROFIT_AND_LOSS_WIDGETS = 'BASIS_DASHBOARD_PROFIT_AND_LOSS_WIDGETS',
  BASIS_DASHBOARD_SAVED_FILTER_FINANCE_WIDGETS = 'BASIS_DASHBOARD_SAVED_FILTER_FINANCE_WIDGETS',
  BASIS_DASHBOARD_OVERSPENDING_WIDGET = 'BASIS_DASHBOARD_OVERSPENDING_WIDGET',

  // --- Раздел BASIS.SECTIONS.SAVED_FILTER ---
  BASIS_SAVED_FILTER_READ = 'BASIS_SAVED_FILTER_READ',

  // --- Раздел BASIS.SECTIONS.COMPANY (Компании) ---
  BASIS_COMPANY_WRITE = 'BASIS_COMPANY_WRITE',
  BASIS_COMPANY_GROUP_WRITE = 'BASIS_COMPANY_GROUP_WRITE',
  BASIS_COMPANY_ERP_1C_WRITE = 'BASIS_COMPANY_ERP_1C_WRITE',
  BASIS_COMPANY_ACCESS_TO_ALL_COMPANIES = 'BASIS_COMPANY_ACCESS_TO_ALL_COMPANIES',

  // --- Раздел BASIS.SECTIONS.CLIENT (Клиенты) ---
  BASIS_CLIENT_WRITE = 'BASIS_CLIENT_WRITE',
  BASIS_CLIENT_CONTRAGENT_WRITE = 'BASIS_CLIENT_CONTRAGENT_WRITE',
  BASIS_CLIENT_CONTRACT_WRITE = 'BASIS_CLIENT_CONTRACT_WRITE',
  BASIS_CLIENT_EXTERNAL_USER_WRITE = 'BASIS_CLIENT_EXTERNAL_USER_WRITE',
  BASIS_CLIENT_BANNER_WRITE = 'BASIS_CLIENT_BANNER_WRITE',
  BASIS_CLIENT_CAN_DELETE_CLIENTS = 'BASIS_CLIENT_CAN_DELETE_CLIENTS',

  // --- Раздел BASIS.SECTIONS.SECURITY (Пользователи) ---
  BASIS_SECURITY_GROUP_READ = 'BASIS_SECURITY_GROUP_READ',
  BASIS_SECURITY_GROUP_WRITE = 'BASIS_SECURITY_GROUP_WRITE',

  BASIS_SECURITY_ROLE_READ = 'BASIS_SECURITY_ROLE_READ',
  BASIS_SECURITY_ROLE_WRITE = 'BASIS_SECURITY_ROLE_WRITE',

  BASIS_SECURITY_USER_READ = 'BASIS_SECURITY_USER_READ',
  BASIS_SECURITY_USER_WRITE = 'BASIS_SECURITY_USER_WRITE',

  BASIS_SECURITY_USER_UNREAD_REPORT_READ = 'BASIS_SECURITY_USER_UNREAD_REPORT_READ',
  BASIS_SECURITY_USER_UNREAD_REPORT_WRITE = 'BASIS_SECURITY_USER_UNREAD_REPORT_WRITE',

  BASIS_SECURITY_WORK_SCHEDULE_READ = 'BASIS_SECURITY_WORK_SCHEDULE_READ',
  BASIS_SECURITY_WORK_SCHEDULE_WRITE = 'BASIS_SECURITY_WORK_SCHEDULE_WRITE',

  BASIS_SECURITY_CAN_BAN_USER = 'BASIS_SECURITY_CAN_BAN_USER',

  BASIS_SECURITY_USER_ACCESS_TO_LIST = 'BASIS_SECURITY_USER_ACCESS_TO_LIST',
  BASIS_SECURITY_GROUP_ACCESS_TO_LIST = 'BASIS_SECURITY_GROUP_ACCESS_TO_LIST',

  // --- Раздел BASIS.SECTIONS.CATALOG (Справочники) ---
  BASIS_CATALOG_DIRECTION_READ = 'BASIS_CATALOG_DIRECTION_READ',
  BASIS_CATALOG_DIRECTION_WRITE = 'BASIS_CATALOG_DIRECTION_WRITE',
  BASIS_CATALOG_UNIT_READ = 'BASIS_CATALOG_UNIT_READ',
  BASIS_CATALOG_UNIT_WRITE = 'BASIS_CATALOG_UNIT_WRITE',
  BASIS_CATALOG_FILIAL_READ = 'BASIS_CATALOG_FILIAL_READ',
  BASIS_CATALOG_FILIAL_WRITE = 'BASIS_CATALOG_FILIAL_WRITE',
  BASIS_CATALOG_ROOM_READ = 'BASIS_CATALOG_ROOM_READ',
  BASIS_CATALOG_ROOM_WRITE = 'BASIS_CATALOG_ROOM_WRITE',
  BASIS_CATALOG_DOCUMENT_TYPE_READ = 'BASIS_CATALOG_DOCUMENT_TYPE_READ',
  BASIS_CATALOG_DOCUMENT_TYPE_WRITE = 'BASIS_CATALOG_DOCUMENT_TYPE_WRITE',
  BASIS_CATALOG_OPERATION_TYPE_READ = 'BASIS_CATALOG_OPERATION_TYPE_READ',
  BASIS_CATALOG_OPERATION_TYPE_WRITE = 'BASIS_CATALOG_OPERATION_TYPE_WRITE',
  BASIS_CATALOG_MASTER_MILESTONE_READ = 'BASIS_CATALOG_MASTER_MILESTONE_READ',
  BASIS_CATALOG_MASTER_MILESTONE_WRITE = 'BASIS_CATALOG_MASTER_MILESTONE_WRITE',
  BASIS_CATALOG_APPROVAL_SCHEME_READ = 'BASIS_CATALOG_APPROVAL_SCHEME_READ',
  BASIS_CATALOG_APPROVAL_SCHEME_WRITE = 'BASIS_CATALOG_APPROVAL_SCHEME_WRITE',
  BASIS_CATALOG_NOMENCLATURE_READ = 'BASIS_CATALOG_NOMENCLATURE_READ',
  BASIS_CATALOG_NOMENCLATURE_WRITE = 'BASIS_CATALOG_NOMENCLATURE_WRITE',
  BASIS_CATALOG_COST_CENTER_READ = 'BASIS_CATALOG_COST_CENTER_READ',
  BASIS_CATALOG_COST_CENTER_WRITE = 'BASIS_CATALOG_COST_CENTER_WRITE',
  BASIS_CATALOG_ACCOUNTING_ACCOUNT_READ = 'BASIS_CATALOG_ACCOUNTING_ACCOUNT_READ',
  BASIS_CATALOG_ACCOUNTING_ACCOUNT_WRITE = 'BASIS_CATALOG_ACCOUNTING_ACCOUNT_WRITE',
  BASIS_CATALOG_AI_READ = 'BASIS_CATALOG_AI_READ',
  BASIS_CATALOG_AI_WRITE = 'BASIS_CATALOG_AI_WRITE',
  BASIS_CATALOG_WEBHOOK_READ = 'BASIS_CATALOG_WEBHOOK_READ',
  BASIS_CATALOG_WEBHOOK_WRITE = 'BASIS_CATALOG_WEBHOOK_WRITE',
  BASIS_CATALOG_DOCUMENT_FILE_TEMPLATE_READ = 'BASIS_CATALOG_DOCUMENT_FILE_TEMPLATE_READ',
  BASIS_CATALOG_DOCUMENT_FILE_TEMPLATE_WRITE = 'BASIS_CATALOG_DOCUMENT_FILE_TEMPLATE_WRITE',
  BASIS_CATALOG_EAV_ENTITY_TYPE_READ = 'BASIS_CATALOG_EAV_ENTITY_TYPE_READ',
  BASIS_CATALOG_EAV_ENTITY_TYPE_WRITE = 'BASIS_CATALOG_EAV_ENTITY_TYPE_WRITE',

  // Permissions
  BASIS_CATALOG_APPROVAL_SCHEME_ACCESS_ALL = 'BASIS_CATALOG_APPROVAL_SCHEME_ACCESS_ALL',
  BASIS_CATALOG_ACCESS_TO_ALL_DIRECTIONS = 'BASIS_CATALOG_ACCESS_TO_ALL_DIRECTIONS',

  // --- Раздел BASIS.SECTIONS.SYSTEM (Админ панель) ---
  BASIS_SYSTEM_BUDGET_CLASSIFICATION_CODE_WRITE = 'BASIS_SYSTEM_BUDGET_CLASSIFICATION_CODE_WRITE',
  BASIS_SYSTEM_CHANGELOG_WRITE = 'BASIS_SYSTEM_CHANGELOG_WRITE',
  BASIS_SYSTEM_CURRENCY_WRITE = 'BASIS_SYSTEM_CURRENCY_WRITE',
  BASIS_SYSTEM_PAYER_STATUS_WRITE = 'BASIS_SYSTEM_PAYER_STATUS_WRITE',
  BASIS_SYSTEM_PLUGIN_1C_WRITE = 'BASIS_SYSTEM_PLUGIN_1C_WRITE',
  BASIS_SYSTEM_RATE_PLAN_WRITE = 'BASIS_SYSTEM_RATE_PLAN_WRITE',
  BASIS_SYSTEM_TENANT_WRITE = 'BASIS_SYSTEM_TENANT_WRITE'
}
